import { Repository } from "react3l-common";
import { kebabCase } from "lodash";
import { httpConfig } from "config/http";
import { BASE_API_URL } from "config/consts";
import { Observable } from "rxjs";
import { AxiosResponse } from "axios";

import nameof from "ts-nameof.macro";

import { API_PROJECT_AUTHORIZATION_REPORT_PREFIX } from "config/api-consts";
import { ProjectParticipant, ProjectParticipantFilter } from "models/ProjectParticipant";
import { Project, ProjectFilter } from "models/Project";
import { Organization, OrganizationFilter } from "models/Organization";
import { AppUser, AppUserFilter } from "models/AppUser";
import { Site, SiteFilter } from "models/Site";

export type KeyType = string | number;

export class ProjectAuthorizationReportRepository extends Repository {
  constructor() {
    super(httpConfig);
    this.baseURL = new URL(API_PROJECT_AUTHORIZATION_REPORT_PREFIX, BASE_API_URL).href;
  }

  public list = (projectParticipantFilter?: ProjectParticipantFilter): Observable<ProjectParticipant[]> => {
    return this.http
      .post<ProjectParticipant[]>(kebabCase(nameof(this.list)), projectParticipantFilter)
      .pipe(Repository.responseMapToList<ProjectParticipant>(ProjectParticipant));
  };

  public export = (filter: any): Observable<AxiosResponse<any>> => {
    return this.http.post("export", filter, {
      responseType: "arraybuffer",
    });
  };

  public singleListProject = (
    projectFilter: ProjectFilter
  ): Observable<Project[]> => {
    return this.http
      .post<Project[]>(
        kebabCase(nameof(this.singleListProject)),
        projectFilter
      )
      .pipe(Repository.responseMapToList<Project>(Project));
  };

  public singleListOrganization = (
    organizationFilter: OrganizationFilter
  ): Observable<Organization[]> => {
    return this.http
      .post<Organization[]>(
        kebabCase(nameof(this.singleListOrganization)),
        organizationFilter
      )
      .pipe(Repository.responseMapToList<Organization>(Organization));
  };

  public singleListAppUser = (
    appUserFilter: AppUserFilter
  ): Observable<AppUser[]> => {
    return this.http
      .post<AppUser[]>(
        kebabCase(nameof(this.singleListAppUser)),
        appUserFilter
      )
      .pipe(Repository.responseMapToList<AppUser>(AppUser));
  };

  public singleListSite = (
    siteFilter: SiteFilter
  ): Observable<Site[]> => {
    return this.http
      .post<Site[]>(
        kebabCase(nameof(this.singleListSite)),
        siteFilter
      )
      .pipe(Repository.responseMapToList<Site>(Site));
  };

}

export const projectAuthorizationReportRepository = new ProjectAuthorizationReportRepository();
